import React, { Component } from 'react'
import PlusIcon from '../../icons/plusicon';
import SearchIcon from '../../icons/searchicon';
import EditIcon from '../../icons/EditIcon';
import DeleteIcon from '../../icons/DeleteIcon';
import FilterIcon from '../../icons/filtericon';
import FilterActiveIcon from '../../icons/filteractiveicon';
import ReactPaginate from "react-paginate";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import service from '../../services';
import { ActCreators } from '../../redux/bindActionCretor';
import Loader from '../../component/loader';
import swal from "sweetalert";

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

let sub;

class AccessControlledPagesList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loaderFlag: false,
            recordList: [],
            offset: 0,
            perPage: 20,
            pageCount: 0,
            currentPage: 0,
            searchField: '',
            statusFilter: [],
            showStatusFilter: false,
        }
        this.apiserve = new service();
        this.searchTimeout = null;
        this.statusFilterRef = React.createRef();
    }

    componentWillUnmount = () => {
        if (sub) sub.unsubscribe();
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        document.removeEventListener('mousedown', this.handleOutsideClick);
    };

    componentDidMount() {
        this.getData();
        document.addEventListener('mousedown', this.handleOutsideClick);

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "accessControl|getList":
                    if (!response.error) {
                        const listData = response?.data || {};
                        const totalDocs = listData.totalDocs || listData.pagination?.totalDocs || 0;
                        this.setState({
                            recordList: listData.data || [],
                            pageCount: totalDocs ? Math.ceil(totalDocs / this.state.perPage) : 0,
                            loaderFlag: false,
                        })
                    }
                    break;
                case "accessControl|delete":
                    if (!response.error) {
                        swal("Your record has been deleted!", {
                            icon: "success",
                        });
                        this.getData();
                    }
                    break;
                case "accessControl|updateStatus":
                    if (!response.error) {
                        this.getData();
                    }
                    break;
                default:
                    break;
            }
        })
    }

    getData = () => {
        this.setState({ loaderFlag: true });
        const data = {
            page: this.state.currentPage + 1,
            limit: this.state.perPage,
        };
        if (this.state.searchField) data.filter = this.state.searchField;
        if (this.state.statusFilter && this.state.statusFilter.length > 0) data.status = this.state.statusFilter;
        this.apiserve.sendevent("accessControl|getList", data);
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
            },
            () => {
                this.getData();
            }
        );
    }

    onSearchFilter = (e) => {
        const value = e.target.value;
        this.setState({ [e.target.name]: value, currentPage: 0 });
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.getData();
        }, 400);
    }

    deleteRecord = (record) => {
        swal({
            title: "Are you sure?",
            text: "You want to delete this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                this.apiserve.sendevent("accessControl|delete", { id: record.id });
            } else {
                swal("Your record is safe!");
            }
        });
    }

    updateStatus = (record) => {
        const newStatus = record.status === 'active' ? 'inactive' : 'active';
        this.apiserve.sendevent("accessControl|updateStatus", {
            id: record.id,
            status: newStatus,
        });
    }

    handleOutsideClick = (e) => {
        if (this.statusFilterRef.current && !this.statusFilterRef.current.contains(e.target)) {
            this.setState({ showStatusFilter: false });
        }
    }

    render() {
        const { recordList } = this.state;
        return (
            <div className="right_side_wrapper access_contolled_pages_list">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="uppercase text_left">
                            <div>ACCESS CONTROLLED PAGES</div>
                            <span onClick={() => this.props.history.push('/access-controlled-pages/create')}>
                                <PlusIcon />
                            </span>
                        </p>
                    </li>
                </ul>
                <div className="dashboard_header no_bg p_0 mt_10 mb_10">
                    <div className="searchBlock back_date pl_15">
                        <form onSubmit={e => { e.preventDefault(); }} className="m_0">
                            <input
                                className="bg_white"
                                type="text"
                                autoComplete="false"
                                placeholder="Search"
                                id="searchField"
                                name="searchField"
                                value={this.state.searchField}
                                onChange={this.onSearchFilter}
                            />
                            <button type='button' style={{ pointerEvents: 'none' }}>
                                <SearchIcon />
                            </button>
                        </form>
                    </div>
                </div>
                <div className="table_wrap dashboard_data film_list_table striped_table">
                    <table>
                        <thead>
                            <tr>
                                <th className="email_d">Name</th>
                                <th className="user_firstName_d">Pages</th>
                                <th className="user_lastName_d" ref={this.statusFilterRef}>
                                    <span
                                        className="disp_flex d_flex_align_center"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.setState(prev => ({ showStatusFilter: !prev.showStatusFilter }))}
                                    >Status
                                        {this.state.statusFilter.length > 0 ?
                                            <FilterActiveIcon /> :
                                            <FilterIcon />
                                        }
                                    </span>
                                    <div className="tabelData_popup" style={{ display: this.state.showStatusFilter ? 'block' : 'none' }}>
                                        <form>
                                            <div className="customCheck">
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => this.setState({ statusFilter: [], currentPage: 0, showStatusFilter: false }, () => this.getData())}>Clear All</p>
                                                </div>
                                                <div className="customCheckBox">
                                                    {[{ label: 'Active', value: 'active' }, { label: 'Inactive', value: 'inactive' }].map((item) => (
                                                        <div className="customCheckBox" key={item.value}>
                                                            <input
                                                                type="checkbox"
                                                                id={`status_filter_${item.value}`}
                                                                checked={this.state.statusFilter.includes(item.value)}
                                                                onChange={(e) => {
                                                                    const current = this.state.statusFilter;
                                                                    const newFilter = e.target.checked
                                                                        ? [...current, item.value]
                                                                        : current.filter(v => v !== item.value);
                                                                    this.setState({ statusFilter: newFilter, currentPage: 0 }, () => this.getData());
                                                                }}
                                                            />
                                                            <label htmlFor={`status_filter_${item.value}`}>{item.label}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </th>
                                <th className="user_company_d">Whitelist Count</th>
                                <th className="depart_d">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(recordList || []).map((record) => {
                                return (
                                    <tr key={record._id}>
                                        <td className="email_d user_email_d">
                                            <strong>{record.name}</strong>
                                        </td>
                                        <td className="firstName_d">
                                            <p>{record.pages?.length || 0}</p>
                                        </td>
                                        <td className="lastName_d">
                                            <div className="switchkBox acp-status-toggle d_flex d_flex_align_center">
                                                <input
                                                    type="checkbox"
                                                    checked={record.status === 'active'}
                                                    onChange={() => this.updateStatus(record)}
                                                />
                                                <span className="slider round"></span>
                                            </div>
                                        </td>
                                        <td className="user_company_d">
                                            <p>{record.whitelistCount}</p>
                                        </td>
                                        <td className="depart_d">
                                            <span
                                                className="pointer mr_10"
                                                onClick={() => this.props.history.push('/access-controlled-pages/' + record?.id)}
                                            >
                                                <EditIcon />
                                            </span>
                                            <span
                                                className="pointer"
                                                onClick={() => this.deleteRecord(record)}
                                            >
                                                <DeleteIcon />
                                            </span>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>

                    {!this.state.loaderFlag && (!recordList || !recordList.length) && (
                        <div className="no_data_found text_center">
                            <p>No records found.</p>
                        </div>
                    )}

                    {this.state.pageCount >= 1 && recordList && recordList.length ? (
                        <div className="custom-pagination">
                            <ReactPaginate
                                previousLabel={""}
                                nextLabel={""}
                                breakLabel={"..."}
                                breakClassName={"break-me"}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={"pagination"}
                                subContainerClassName={"pages pagination"}
                                activeClassName={"active"}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                    ) : null}

                    {/* Loader */}
                    {this.state.loaderFlag ? (
                        <Loader />
                    ) : (
                        ""
                    )}
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccessControlledPagesList)
